var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
import { useEffect, useMemo, useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'app/components/Form';
import { documentTitle } from 'app/components/DocumentTitle/DocumentTitle.jsx';
import { TableTasksRedux } from '../Project/Tasks/TableTasksRedux';
import allRequests from 'app/pages/Project/Tasks/tasksRequests';
import getProjectIdFromURL from 'app/core/utils/getProjectIdFromURL.js';
import { useProgress } from 'app/hooks/useProgress.js';
import { getAssetsAttributValues } from 'app/store/selectors/getAssetsAttributValues';
import { getResources } from 'app/store/selectors';
import { getSubResources } from 'app/store/resources/utils/getSubResources';
import { useDispatch, useSelector } from 'react-redux';
import { map, pickBy } from 'lodash';
import { fetchMyPastTasks, fetchMyTasks } from 'app/store/reducers/tasks';
import { flattenTakesFromTasksSelector } from 'app/store/selectors/tasks';
import { Filters as DefaultFilters } from 'app/pages/Project/Tasks/Filters.js';
import { tableFiltersDataSelector, tableFiltersForQueriesSelector } from 'app/store/selectors/tablesFilters';
import { urlToFilters, filtersToQueries } from 'app/components/Table/hooks/useFiltersUtils.js';
import routerHistory from 'app/main/routerHistory.js';
import { filtersToURL } from 'app/components/Table/hooks/useFiltersUtils.js';
import { getURLParamsKey } from 'app/components/Table/utils.js';
import { setTableId } from 'app/store/reducers/tablesPrefs';
import { tableUserPrefsDataSelector } from 'app/store/selectors/tableUserPrefs';
import { userPrefLocalResource } from 'app/core/utils/localUserPrefs.js';
import { resetReduxFilters, setAndApplyInputFilters } from 'app/store/reducers/tablesFilters';
import { useLocation } from 'react-router-dom';
export const tableId = 'MyTaskTableTask';
export function MyTasks() {
    var _a, _b;
    const dispatch = useDispatch();
    const { search } = useLocation();
    const [pastTasks, setPastTasks] = useState(false);
    const [requestsLoading, setRequestsLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [filtersloading, setFiltersLoading] = useState(true);
    const { initProgresses, updateProgress, progress } = useProgress();
    const projectId = getProjectIdFromURL();
    const data = useSelector(flattenTakesFromTasksSelector);
    const { loading, count } = useSelector((state) => state.reduxTasks);
    const table = (_a = userPrefLocalResource.getData('tables')) === null || _a === void 0 ? void 0 : _a[tableId];
    const filtersData = useSelector(tableFiltersDataSelector);
    const ordering = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.tablesPrefs.data) === null || _a === void 0 ? void 0 : _a[tableId]) === null || _b === void 0 ? void 0 : _b.sortBy) === null || _c === void 0 ? void 0 : _c.orderingString; });
    const tableUserPrefs = useSelector(tableUserPrefsDataSelector(tableId));
    const filtersForQueries = useSelector(tableFiltersForQueriesSelector);
    const categories = ((_b = getAssetsAttributValues(undefined, 'category')) === null || _b === void 0 ? void 0 : _b.values) || [];
    const projects = getResources(undefined, 'assets', { assetType: 'pj' });
    const episodes = useSelector((state) => pickBy(state.assets.resources, (asset) => asset.assetType === 'ep' && asset.project === getProjectIdFromURL()));
    const progressionStatus = useSelector((state) => state.progressionStatus.resources);
    const assetsAttributes = map(getResources(undefined, 'attributes', projectId ? { project: projectId } : undefined));
    const steps = () => {
        const stepProjects = getResources(undefined, 'stepProjects', projectId ? { project: projectId } : undefined, [
            'stepInst',
        ]);
        if (projectId)
            return getSubResources(stepProjects, 'stepInst');
        return getResources(undefined, 'steps');
    };
    documentTitle(pastTasks ? 'Past tasks' : '');
    const filters = useMemo(() => {
        if (!requestsLoading) {
            const filt = new DefaultFilters({
                episodes,
                categories,
                progressionStatus,
                assetsAttributes,
                projects,
            }).getFilters();
            return filt;
        }
    }, [requestsLoading]);
    useEffect(() => {
        dispatch(setTableId(tableId));
        return () => {
            dispatch(resetReduxFilters());
        };
    }, []);
    useEffect(() => {
        ;
        (() => __awaiter(this, void 0, void 0, function* () {
            yield allRequests({ projectId });
            setRequestsLoading(false);
        }))();
    }, []);
    useEffect(() => {
        ;
        (() => __awaiter(this, void 0, void 0, function* () {
            if (search && (filters === null || filters === void 0 ? void 0 : filters.length) && filtersloading) {
                const params = new URLSearchParams(search);
                const urlCurrentFilters = params.get(getURLParamsKey('filters', tableId));
                if (urlCurrentFilters) {
                    const urlFilters = yield urlToFilters(urlCurrentFilters, filters, undefined, undefined, false);
                    dispatch(setAndApplyInputFilters(urlFilters));
                }
                setFiltersLoading(false);
            }
            if (!search && (filters === null || filters === void 0 ? void 0 : filters.length) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length)) {
                dispatch(resetReduxFilters());
                setFiltersLoading(false);
            }
            else if (!search && (filters === null || filters === void 0 ? void 0 : filters.length)) {
                setFiltersLoading(false);
            }
        }))();
    }, [filters]);
    useEffect(() => {
        const url = filtersToURL(filtersData !== null && filtersData !== void 0 ? filtersData : []);
        routerHistory.updateQuery({ [getURLParamsKey('filters', tableId)]: url || null });
    }, [filtersData]);
    useEffect(() => {
        if (!requestsLoading && !filtersloading) {
            const { queries: filtQueries } = filtersToQueries(filtersForQueries !== null && filtersForQueries !== void 0 ? filtersForQueries : []);
            const params = {
                queries: Object.assign({ status__statusType__in: pastTasks ? '3' : '0,2,4', page_size: (tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize) || (table === null || table === void 0 ? void 0 : table.pageSize) || 50, page: page + 1, 'taskType__name!': 'alt', ordering }, filtQueries),
            };
            pastTasks ? dispatch(fetchMyPastTasks(params)) : dispatch(fetchMyTasks(params));
        }
    }, [requestsLoading, pastTasks, filtersForQueries, ordering, page, tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize, filtersloading]);
    return (_jsx("div", { className: "fullWidth fullHeight", children: _jsx(TableTasksRedux, { swapTableType: _jsxs(ToggleButtonGroup, { children: [_jsx(ToggleButton, { icon: "far-square", onClick: () => setPastTasks(false), selected: !pastTasks, children: "Current tasks" }), _jsx(ToggleButton, { icon: "fas-check-square", onClick: () => setPastTasks(true), selected: pastTasks, children: "Past tasks" })] }), tableId: tableId, enableAddTime: true, data: data, projectId: projectId, loading: loading, count: count, requestsLoading: requestsLoading, assetsAttributes: assetsAttributes, progressionStatus: progressionStatus, steps: steps, projects: projects, filters: filters, progress: progress, page: page, setPage: setPage }) }));
}
